"use client"

import { useState } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import axios from "axios";
import { toast } from 'sonner';
import { setUserData } from "@/store/mainSlice";
import { useDispatch } from "react-redux";
import { useRouter } from 'next/navigation';


export function AuthForm({ setIsSuccessful, children, defaultEmail = "" }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch()
  const router = useRouter()


  const handleChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setFormData((old) => {
      return {
        ...old,
        [key]: value
      }
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSuccessful(true)
    try {
      const res = await axios.post(process.env.NEXT_PUBLIC_APP_SIGN_IN, {
        email: btoa(formData.email),
        password: btoa(formData.password)
      },
        {
          headers: {
            "x-auth-token": process.env.NEXT_PUBLIC_APP_SEND_HEADERS,
          },
        }
      );
      const token = res.data.token;
      localStorage.setItem("authToken", token);
      localStorage.setItem("userId", res.data.data._id);

      toast.success("Login Successful!", {
        style: { color: "green" }, // only text color
        position: "top-center",
        iconTheme: { primary: "green", secondary: "#fff" },
      });
      // console.log(res.data.data, "userLoginData")
      const filteredUser = {
        id: res.data.data._id,
        token: res.data.token,
        name: res.data.data?.name,
        email: res.data.data?.email,
      };
    
      try {
        await axios.post(
          `${process.env.NEXT_PUBLIC_APP_SITE_WEBSITE_URL}api/users/set-cookie`,
          { user: filteredUser },
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": "",
            },
            withCredentials: true,
          }
        );
      } catch (err) {
        console.warn("Set-cookie failed, but login succeeded", err.message);
      }
      dispatch(setUserData(res.data.data))
      // router.push("/");
      const redirectPath = localStorage.getItem("postLoginRedirect");
      if (redirectPath) {
        localStorage.removeItem("postLoginRedirect");
        router.replace(redirectPath);
      } else {
        router.replace("/explore-agents");
      }
    } catch (err) {
      console.error(err);
       const errorMessage =
    err?.response?.data?.message || err?.message ||               
    "Something went wrong. Please try again.";

      toast.error(errorMessage, {
        style: { color: "red" }, // only text color
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" },
      });
    } finally {
      setIsSuccessful(false)
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 sm:px-0 px-0 "
    >
      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="email"
        >
          Email Address
        </Label>

        <Input
          autoComplete="email"
          autoFocus
          className="bg-muted text-md md:text-sm focus:outline-none"
          id="email"
          name="email"
          placeholder="user@gmail.com"
          required
          type="email"
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="password"
        >
          Password
        </Label>

        <Input
          className="bg-muted text-md md:text-sm focus:outline-none"
          id="password"
          name="password"
          required
          type="password"
          value={formData.password}
          onChange={handleChange}
        />
      </div>
      {children}
    </form>
  );
}
